export const PRODUCT_ITEM_VIEW_PROPERTIES = {
  showProductTitle: false,
  showProductHeader: false,
  showProductCardIcons: false,
  showProductPrices: false,
};
